import { render, staticRenderFns } from "./ItemDummy.vue?vue&type=template&id=6b57c379&scoped=true&"
import script from "./ItemDummy.vue?vue&type=script&lang=js&"
export * from "./ItemDummy.vue?vue&type=script&lang=js&"
import style0 from "./ItemDummy.vue?vue&type=style&index=0&id=6b57c379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57c379",
  null
  
)

export default component.exports